// extracted by mini-css-extract-plugin
export var addButton = "_4x-d";
export var bullets = "_4x-e";
export var compact = "_4x-2";
export var container = "_4x-j";
export var extendedWarrantyModal = "_4x-f";
export var learn = "_4x-l";
export var learnMore = "_4x-g";
export var offeringOption = "_4x-3";
export var offeringPrice = "_4x-8";
export var offeringSubtitle = "_4x-7";
export var offeringTitle = "_4x-6";
export var offeringsContainer = "_4x-0";
export var pdpTilesBackground = "_4x-n";
export var plan = "_4x-m";
export var regular = "_4x-1";
export var remove = "_4x-k";
export var seeDetailsIcon = "_4x-i";
export var seeDetailsLink = "_4x-h";
export var selectedOption = "_4x-4";
export var shieldIcon = "_4x-b";
export var shieldIconCompact = "_4x-c";
export var subtitle = "_4x-a";
export var title = "_4x-9";
export var unselectedOption = "_4x-5";